import React, { Component } from 'react'
import PropTypes from 'prop-types'
import EmptyTableImage from './images/empty_table.svg'
import ArticleModalContent from 'components/ModalContent/ArticleModalContent'
import { Button, Modal } from '@driftt/tide'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from 'modules/knowledgebase/actions'

import { TABLE_TYPE_CATEGORY } from './constants'

import './style.css'

class EmptyTable extends Component {
  static propTypes = {
    tableType: PropTypes.string
  }
  
  static defaultProps = {
    tableType: TABLE_TYPE_CATEGORY
  }
  
  state = {
    isArticleModalOpen: false
  }
  
  clearArticle = () => {
    if (!this.state.isArticleModalOpen) {
      const { actions } = this.props
      actions.clearArticle()
    }
  }
  
  toggleModal = () => {
    this.clearArticle()
    
    this.setState(prevState => ({
      isArticleModalOpen: !prevState.isArticleModalOpen
    }))
  }
  
  
  render() {
    const { tableType } = this.props
    const { isArticleModalOpen } = this.state
    
    return (
      <div className='empty-table-container'>
        <img src={EmptyTableImage} alt='Empty table'/>
        <p className='empty-table-text'>
          There aren’t any articles in this
          {tableType === TABLE_TYPE_CATEGORY ? ` category` : ` section`} yet.
          Make the first one and share that knowledge!
        </p>
        
        <Button onClick={this.toggleModal}>Create New Article</Button>
        
        <Modal
          size="medium"
          open={isArticleModalOpen}
          onClose={this.toggleModal}
        >
          <ArticleModalContent {...this.props} onCloseModal={this.toggleModal}/>
        </Modal>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    clearArticle: actions.clearArticle
  }, dispatch)
})
export default connect(null, mapDispatchToProps)(EmptyTable)